/* global require */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import TarotReadingQuestion from './tarot/readings/tarot-reading/question';
import { MediaQuery } from '../media-query';
import { smoothScrollToElement } from '../scroll';
import ReadingHeaderPrice from './reading-header-price';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.slant = props.slant == 'free' ? 'general' : props.slant;

        if (MediaQuery.isMobile()) {
            this.Shake = require('shake.js');
            this.shakeEvent = new this.Shake({ threshold: 5 });
            this.shakeEvent.start();
            window.addEventListener('shake', this.shakeHappened);
        }

        props.init(props.product.code);

        this.state = {
            accordionOpen: false,
            coins: [
                {
                    speed: 0,
                    rotation: 180,
                    frame: 18,
                    timer: null,
                },
                {
                    speed: 0,
                    rotation: 180,
                    frame: 18,
                    timer: null,
                },
                {
                    speed: 0,
                    rotation: 180,
                    frame: 18,
                    timer: null,
                },
            ],
            done: false,
            isPlaying: false,
            isStopping: false,
            length: 23,
            lines: [],
            start: 0,
            started: false,
            stopTimer: null,
            value: 0,
        };

        const icon_url = `https://gfx.tarot.com/images/iching/iching-${this.slant}/icon.svg`;
        const style_sheet = document.createElement('style');
        const style_rules = [
            `i-ching-reading .icon-teeup { background-image: url(${icon_url}); }`,
        ];

        style_rules.forEach((rule) => {
            style_sheet.appendChild(document.createTextNode(rule));
        });

        document.head.appendChild(style_sheet);

        this.positions = {
            1: { heads: 0, tails: 3, value: 6},
            2: { heads: 2, tails: 1, value: 8},
            3: { heads: 1, tails: 2, value: 7},
            4: { heads: 3, tails: 0, value: 9},
            5: { heads: 2, tails: 1, value: 8},
            6: { heads: 1, tails: 2, value: 7},
            7: { heads: 2, tails: 1, value: 8},
            8: { heads: 1, tails: 2, value: 7},
            9: { heads: 3, tails: 0, value: 9},
            10: { heads: 2, tails: 1, value: 8},
            11: { heads: 1, tails: 2, value: 7},
            12: { heads: 2, tails: 1, value: 8},
            13: { heads: 3, tails: 0, value: 9},
            14: { heads: 2, tails: 1, value: 8},
            15: { heads: 1, tails: 2, value: 7},
            16: { heads: 2, tails: 1, value: 8},
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState != this.state) {
            return true;
        }

        if (nextProps.product != this.props.product) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        if (nextProps.subject != this.props.subject) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        if (typeof this.Shake !== 'undefined') {
            window.removeEventListener('shake', this.shakeHappened);
            this.shakeEvent.stop();
        }
    }

    render({ product, submitting }) {
        return (
            <i-ching-reading slant={this.slant}>
                <header>
                    <ReadingHeaderPrice />
                    <div className='icon-teeup' />
                    <h1 className={`reading-header i-ching-${this.slant}`}>
                        {product.product_name.replace('Sample ', '').replace(' Reading', '')}
                    </h1>
                    <p>
                        {this.props.product.subheader}&nbsp;
                        <a href='#' onClick={this.toggleAccordion} data-action='Click-Learn-More'>Learn More</a>
                    </p>
                </header>
                {this.renderAside()}
                <TarotReadingQuestion placeholder='To help you focus, enter a Subject here (optional)' />
                <section
                    className={`i-ching-reading-coins ${this.state.started && !this.state.done ? 'started' : ''}`}
                    onClick={this.toss}
                >
                    <h3 className={`i-ching-${this.slant} ${this.state.done ? 'done' : ''}`}>{this.renderH3Text()}</h3>
                    <i-ching-coin>{this.renderCoinImages(0)}</i-ching-coin>
                    <i-ching-coin>{this.renderCoinImages(1)}</i-ching-coin>
                    <i-ching-coin>{this.renderCoinImages(2)}</i-ching-coin>
                </section>
                <section className='i-ching-reading-lines' onClick={this.toss}>
                    {this.renderLines()}
                </section>
                <div className='button-wrapper'>
                    <button
                        className={`button ${this.state.done ? '' : 'disabled'} i-ching-${this.slant}`}
                        action='Click-Reveal-Meaning-Button'
                        onClick={this.submit}
                    >
                        {submitting ? 'SUBMITTING…' : 'REVEAL THE MEANING'}
                    </button>
                </div>
            </i-ching-reading>
        );
    }

    renderCoinImages = (coin) => {
        return Array.apply(null, {length: 23}).map(Function.call, Number).map(n => (
            <img
                src={`https://gfx.tarot.com/images/iching/iching-${this.slant}/coin/${n + 1}.gif`}
                style={`
                  transform: rotate(${this.state.coins[coin].rotation}deg);
                  opacity: ${this.state.coins[coin].frame == (n + 1) ? 1 : 0};
              `}
            />
        ));
    }

    setRotationAndSpeed = () => {
        let state = this.state;

        state.coins[0].speed = Math.floor(Math.random() * (30 - 20 + 1)) + 20;
        state.coins[0].rotation = Math.floor((Math.random() * 360) + 1);
        state.coins[1].speed = Math.floor(Math.random() * (30 - 20 + 1)) + 20;
        state.coins[1].rotation = Math.floor((Math.random() * 360) + 1);
        state.coins[2].speed = Math.floor(Math.random() * (30 - 20 + 1)) + 20;
        state.coins[2].rotation = Math.floor((Math.random() * 360) + 1);

        this.setState(state);
    }

    shakeHappened = () => {
        if (this.state.lines.length < 6) {
            this.toss();
            setTimeout(this.toss, 1000);
        }
    }

    toss = () => {
        if (!this.state.done) {
            if (!this.state.isPlaying && !this.state.isStopping) {
                let state = this.state;

                smoothScrollToElement(document.querySelector('.i-ching-reading-coins'));

                this.setRotationAndSpeed();

                const start = performance.now();
                const timer0 = setInterval(() => { this.rotate(0); }, state.coins[0].speed);
                const timer1 = setInterval(() => { this.rotate(1); }, state.coins[1].speed);
                const timer2 = setInterval(() => { this.rotate(2); }, state.coins[2].speed);

                state.isPlaying = true;
                state.start = start;
                state.started = true;
                state.value = 0;
                state.coins[0].timer = timer0;
                state.coins[1].timer = timer1;
                state.coins[2].timer = timer2;

                this.setState(state);
            } else if (!this.state.isStopping) {
                const stop = performance.now();
                const wheel_start = Math.floor(Math.random() * 16) + 1;
                const positions_moved = parseInt(stop - this.state.start);
                const wheel_end = ((positions_moved + wheel_start) % 16) + 1;
                const result = this.positions[wheel_end];
                let frames = [];

                //heads = frame 6, tails = frame 18
                if (result.value == 6) { // all tails
                    frames = this.randomizeCoins([18, 18, 18]);
                } else if (result.value == 7) { // one heads, two tails
                    frames = this.randomizeCoins([6, 18, 18]);
                } else if (result.value == 8) { // two heads, one tails
                    frames = this.randomizeCoins([6, 6, 18]);
                } else if (result.value == 9) { // all heads
                    frames = this.randomizeCoins([6, 6, 6]);
                }

                const stopTimer = setInterval(() => { this.stop(frames, result); }, 10);

                this.setState({
                    isPlaying: false,
                    isStopping: true,
                    stopTimer: stopTimer,
                });
            }
        } else {
            this.submit();
        }
    }

    rotate = (coin) => {
        let state = this.state;
        const nextFrame = state.coins[coin].frame < state.length
            ? state.coins[coin].frame + 1
            : 1;

        state.coins[coin].frame = nextFrame;

        this.setState(state);
    }

    stop = (frames, result) => {
        let state = this.state;

        if (state.coins[0].frame == frames[0]) {
            clearInterval(state.coins[0].timer);
            state.coins[0].timer = null;
        }

        if (state.coins[1].frame == frames[1]) {
            clearInterval(state.coins[1].timer);
            state.coins[1].timer = null;
        }

        if (state.coins[2].frame == frames[2]) {
            clearInterval(state.coins[2].timer);
            state.coins[2].timer = null;
        }

        if (
            state.coins[0].frame == frames[0]
            &&
            state.coins[1].frame == frames[1]
            &&
            state.coins[2].frame == frames[2]
        ) {
            clearInterval(state.stopTimer);

            state.isStopping = false;
            state.stopTimer = null;
            state.lines.push(result.value);

            if (state.lines.length == 6) {
                state.done = true;
            }
        }

        this.setState(state);
    }

    randomizeCoins(results) {
        let m = results.length;
        let t;
        let i;

        while (m) {
            i = Math.floor(Math.random() * m--);

            t = results[m];
            results[m] = results[i];
            results[i] = t;
        }

        return results;
    }

    toggleAccordion = (e) => {
        e.preventDefault();
        this.setState({ accordionOpen: !this.state.accordionOpen });
    }

    renderAside = () => {
        if (this.state.accordionOpen) {
            return (
                <aside className='details'>
                    <a className='button' onClick={this.toggleAccordion}>✕</a>
                    <h3>{this.props.product.product_name} description</h3>
                    <summary>
                        {this.props.product.long_description.split('\n').map(p => (
                            <p>{p}</p>
                        ))}
                    </summary>
                </aside>
            );
        }

        return null;
    }

    renderH3Text = () => {
        let text = 'TAP';

        if (!this.state.done) {
            if (MediaQuery.isMobile()) {
                text += ' OR SHAKE';
            }

            text += ' TO TOSS COINS';

            if (!this.state.lines.length) {
                text += ' 6 TIMES';
            } else {
                text += ` ${6 - this.state.lines.length} MORE TIME`;

                if (this.state.lines.length < 5) {
                    text += 'S';
                }
            }
        } else {
            text += ' TO REVEAL MEANING';
        }

        return text;
    }

    renderLines = () => {
        return [0, 1, 2, 3, 4, 5].map(toss => {
            const img_path = `https://gfx.tarot.com/images/iching/iching-${this.slant}/hexagram-lines/`;
            let img_filename = 'ghost-line.svg';

            if (typeof this.state.lines[toss] !== 'undefined') {
                if (this.state.lines[toss] == 6) { // all heads: changes from -- -- to -----
                    img_filename = 'broken-changing.svg';
                } else if (this.state.lines[toss] == 7) { // two heads, one tails: non-changing
                    img_filename = 'solid-line.svg';
                } else if (this.state.lines[toss] == 8) { // one heads, two tails: non-changing
                    img_filename = 'broken-line.svg';
                } else if (this.state.lines[toss] == 9) { // all tails: changes from ----- to -- --
                    img_filename = 'solid-changing.svg';
                }
            }

            return (
                <div className='i-ching-reading-line'>
                    <img src={`${img_path}${img_filename}`} />
                </div>
            );
        });
    }

    submit = () => {
        if (this.state.done) {
            this.props.submit({
                question: this.props.subject,
                lines: this.state.lines,
            });
        }

        return false;
    }
}

const mapStateToProps = (state) => ({
    product: state.product && state.product.description,
    submitting: state.product && state.product.submitting,
    subject: (state['tarot-reading'] && state['tarot-reading'].subject),
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    init: (upc) => dispatch({ type: 'i-ching-reading:init', payload: { upc: upc } }),
    submit: (payload) => dispatch({ type: 'i-ching-reading:submit', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
